// extracted by mini-css-extract-plugin
var _1 = "PageFooter-modulePageFooter__VXIi5";
export { _1 as "PageFooter" }
